import "../../../assets/scss/account-style.scss";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "../../store/hooks";

export const ESGReport = () => {
  const { t } = useTranslation();
  const userState = useAppSelector((state: any) => state.user);

  return (
    <div style={{ background: "#000" }}>
      <video width="100%" height="100%" autoPlay={true}>
        <source src={`./videos/performance.mp4`} type="video/mp4" />
      </video>
    </div>
  );
};
